import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearMultipleData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useSettings() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const saveNotificationSettingStatus = getStatus(state, apiKeys.saveNotificationSettingsList, '');
  const updateNotificationSettingStatus = getStatus(state, apiKeys.updateZoneMaster, '');
  const notificationSettingData = getData(state, apiKeys.notificationSettingsList, []);
  const notificationSettingStatus = getStatus(state, apiKeys.notificationSettingsList, '');
  const notificationSettingErrMsg = getErrorMessage(state, apiKeys.notificationSettingsList, '');
  const deletenotificationSettingStatus = 
  getStatus(state, apiKeys.deleteNotificationSettingsList, '');

  const getNotificationList = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.notificationSettingsList,
      method: apiMethods.GET,
      key: apiKeys.notificationSettingsList,
      failureMsg: formatMessage({ id: "failed-to-get-zone-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getNotificationList()
  }, [dispatch, getNotificationList]);

  useEffect(() => {
    if (deletenotificationSettingStatus === apiStatuses.succeeded) {
      getNotificationList();
    }
  }, [deletenotificationSettingStatus, getNotificationList])

  useEffect(() => () => {
    dispatch(clearMultipleData({ key: apiKeys.notificationSettingsList }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);

  useEffect(() => {
    if (saveNotificationSettingStatus === apiStatuses.succeeded) {
      closeModal(); 
      getNotificationList();
    } 
  }, [saveNotificationSettingStatus, closeModal, getNotificationList]);

  useEffect(() => {
    if (updateNotificationSettingStatus === apiStatuses.succeeded) {
      closeModal(); 
      getNotificationList();
    } 
  }, [updateNotificationSettingStatus, closeModal, getNotificationList]);

  return useMemo(() => ({
    notificationSettingData,
    notificationSettingStatus,
    notificationSettingErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    notificationSettingData,
    notificationSettingStatus,
    notificationSettingErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
